import { useState, useEffect, useContext } from 'react'
import EnvContext from '../context/EnvContext'

import { gql, useQuery } from '@apollo/client';

export const useAccountRiskLimits = (acctId) => {

    const ACCOUNT_RISK_QUERY = gql`
    query($envName: String!, $itemId: bigint!) {
        riskLimitsData(where: {envName: {_eq: $envName}, itemId: {_eq: $itemId}}) {
          riskData
        }
      }
    `

    const envSelected = useContext(EnvContext)
    const [lookupData, setLookupData] = useState({})
    const { data, loading } = useQuery(ACCOUNT_RISK_QUERY, {
        variables: {
            "envName": envSelected,
            "itemId": acctId
        }
    })

    

    useEffect(() => {
        if (!loading && data) {
            let riskDataAll = {}
            data.riskLimitsData.forEach(limit => {
                console.log(limit.riskData)
                riskDataAll = limit.riskData
            });
            setLookupData(riskDataAll)
        }
    }, [data, loading, acctId])

    return lookupData
}

export default useAccountRiskLimits